import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import { Box, Popper, Paper, ClickAwayListener, Grow } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faCaretUp, faSignOut } from '@fortawesome/free-solid-svg-icons';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useSelector } from 'react-redux';

const TransparentAppBar = styled(AppBar)({
    background: 'transparent',
    boxShadow: 'none',
    paddingLeft: 0,
    paddingRight: 0,
    margin: 0
});

const MenuPaper = styled(Paper)({
    position: 'relative',
    '&::before': {
        content: '""',
        position: 'absolute',
        top: '-10px',  // Adjusts the position of the triangle above the menu
        right: '10px', // Adjusts the horizontal position of the triangle
        width: 0,
        height: 0,
        borderLeft: '10px solid transparent',
        borderRight: '10px solid transparent',
        borderBottom: '10px solid white', // Color of the triangle, matching the menu background
    }
});

const HamburgerMenu = (props) => {
    const { logout } = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [profileVisible, setProfileVisible] = useState(true);
    const { userData } = useSelector((state) => state.login);

    // useEffect(() => {
    //     if (anchorEl) {
    //         document.body.style.backgroundColor = 'grey';
    //     } else {
    //         document.body.style.backgroundColor = '';
    //     }

    //     return () => {
    //         document.body.style.backgroundColor = '';
    //     };
    // }, [anchorEl]);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
        setProfileVisible(false);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
        setProfileVisible(true);
    };

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;

    const hideStyle = {
        overflow: 'hidden',
        padding: '0 5px',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        width: '100%' // Note: !important is not needed here
    };

    return (
        <div style={{ padding: 0, margin: 0 }}>
            <TransparentAppBar position="static">
                <Toolbar
                    sx={{
                        paddingLeft: '0px !important',
                        paddingRight: '0px !important',
                        padding: 0,
                        margin: 0,
                    }}
                >
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={handleMenuOpen}
                        sx={{ padding: 0, margin: 0, cursor: 'pointer' }}
                    >
                        <AccountCircleIcon />
                        <label style={{ paddingLeft: '8px', paddingRight: '8px', fontSize: '15px', cursor: 'pointer' }}>Profile</label>
                        {profileVisible ? (
                            <FontAwesomeIcon icon={faCaretDown} className="updown" />
                        ) : (
                            <FontAwesomeIcon icon={faCaretUp} className="updown" />
                        )}
                    </IconButton>
                </Toolbar>
            </TransparentAppBar>
            <Popper
                id={id}
                open={open}
                anchorEl={anchorEl}
                transition
                placement="bottom-start"
                sx={{ zIndex: 200, paddingRight: '10px' }}
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [-10, 15], // Adjust the offset value to position it better
                        },
                    },
                    {
                        name: 'preventOverflow',
                        options: {
                            mainAxis: true,
                            altAxis: true,
                            tether: false,
                            boundary: 'viewport',
                        },
                    },
                ]}
            >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps}>
                        <MenuPaper sx={{ boxShadow: "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px", backgroundColor: "white" }}>
                            <ClickAwayListener onClickAway={handleMenuClose}>
                                <Box sx={{ width: 320, cursor: 'pointer' }}>
                                    <MenuItem sx={{ height: 65, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', borderBottom: '1px solid lightgrey' }}>
                                        <Box sx={{ fontSize: '0.80rem', color: 'gray' }}>Company Name</Box>
                                        <Box sx={{ fontSize: '1rem', fontWeight: '600', color: 'grey', ...hideStyle }} title={userData?.companyName}>{userData?.companyName}</Box>
                                    </MenuItem>
                                    <MenuItem sx={{ height: 65, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', borderBottom: '1px solid lightgrey' }}>
                                        <Box sx={{ fontSize: '0.80rem', color: 'gray' }}>Branch Name</Box>
                                        <Box sx={{ fontSize: '1rem', fontWeight: '600', color: 'grey', ...hideStyle }} title={userData?.branchName}>{userData?.branchName}</Box>
                                    </MenuItem>
                                    <MenuItem sx={{ height: 65, display: 'flex', flexDirection: 'column', alignItems: 'flex-start', borderBottom: '1px solid lightgrey' }}>
                                        <Box sx={{ fontSize: '0.80rem', color: 'gray' }}>User Name</Box>
                                        <Box sx={{ fontSize: '1rem', fontWeight: '600', color: 'grey', ...hideStyle }} title={userData?.userName}>{userData?.userName}</Box>
                                    </MenuItem>
                                    <MenuItem
                                        sx={{
                                            height: 65,
                                            fontSize: '1.2rem',
                                            fontWeight: '600',
                                            color: '#104FA2',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            cursor: 'pointer'
                                        }}
                                        onClick={logout}
                                    >
                                        <FontAwesomeIcon icon={faSignOut} />
                                        <label style={{ paddingLeft: '10px', cursor: 'pointer' }}>Logout</label>
                                    </MenuItem>
                                </Box>
                            </ClickAwayListener>
                        </MenuPaper>
                    </Grow>
                )}
            </Popper>
        </div >
    );
};

export default HamburgerMenu;
